export enum CallHistoryStatusE {
  CONFIRMED = 'confirmed',
  REJECTED = 'Rejected',
  CANCELED = 'Canceled',
  SIP_FAILURE_CODE = 'SIP Failure Code',
  INCOMPATIBLE_SDP = 'Incompatible SDP',
  AUTHENTICATION_ERROR = 'Authentication Error',
  ADDRESS_INCOMPLETE = 'Address Incomplete',
  UNAVALIABLE = 'Unavailable',
  NOT_FOUND = 'Not Found',
  REDIRECTED = 'Redirected',
  BUSY = 'Busy',
  FAILED = 'failed',
  DISCONNECTED = 'disconnected',
  NO_ANSWER = 'No Answer',
  UNDEFINED = 'Undefined',
  CALL_INITIATED = 'call_initiated',
}

export enum CallHistoryTypeE {
  LOCAL = 'local',
  REMOTE = 'remote',
}

export enum CallReasonDisconnectE {
  PAGE_REFRESH = 'page_refresh',
}
